import { render, staticRenderFns } from "./bookings-details.vue?vue&type=template&id=02fb4e93&"
import script from "./bookings-details.vue?vue&type=script&lang=js&"
export * from "./bookings-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports